import zh from './zh'
import en from './en'
import de from './de'
import fr from './fr'
export default {
  'zh-cn': zh, // 中文语言包
  'en-us': en, // 英文语言包
  de, // 德语语言包
  fr // 法语语言包
}
